import React from 'react';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import { RootTab } from 'src/navigation/TabNavigation';
import withSuspense from 'src/navigation/withSuspense';
const Home = withSuspense(React.lazy(async () => {
    return import('./screens/Home');
}));
export const renderNotificationTabRoutes = ({ translate, isRegistered, unreadCount, }) => {
    return (React.createElement(RootTab.Group, null, isRegistered && (React.createElement(RootTab.Screen, { name: "Notification_Home", options: {
            tabBarLabel: translate('Notifications'),
            tabBarIcon: props => React.createElement(FeatherIcon, { name: "bell", ...props }),
            tabBarBadge: unreadCount > 0 ? unreadCount : undefined,
        }, component: Home }))));
};
